import { FaBuilding, FaHardHat, FaTools, FaCity } from 'react-icons/fa';
import { FaHelmetSafety } from 'react-icons/fa6';

const history = [
  {
    id: 1,
    icon: <FaBuilding />, // Foundation
    title: 'Foundation of {Excellence}',
    content: 'Established with a vision to deliver high-quality construction services, focusing on precision and durability.',
    years: '2001 - 2004',
  },
  {
    id: 2,
    icon: <FaHardHat />, // Expansion
    title: 'Expanding Our {Reach}',
    content: 'Grew our portfolio with large-scale commercial and residential projects, setting industry benchmarks.',
    years: '2005 - 2010',
  },
  {
    id: 3,
    icon: <FaTools />, // Innovation
    title: 'Innovation & {Technology}',
    content: 'Adopted modern construction techniques and sustainable practices to enhance project efficiency.',
    years: '2011 - 2015',
  },
  {
    id: 4,
    icon: <FaCity />, // Milestones
    title: 'Major {Milestones}',
    content: 'Completed landmark projects, earning recognition for quality craftsmanship and reliability.',
    years: '2016 - 2020',
  },
  {
    id: 5,
    icon: <FaHelmetSafety />, // Excellence
    title: 'Commitment to {Excellence}',
    content: 'Continuing to innovate, build, and inspire with a commitment to delivering top-tier construction solutions.',
    years: '2021 - 2022',
  },
  {
    id: 6,
    icon: <FaHelmetSafety />, // Ongoing
    title: 'Building the {Future}',
    content: 'Continuing to innovate, build, and inspire with a commitment to delivering top-tier construction solutions.',
    years: '2023 - Present',
  },
];

export default history;